import { useTranslation } from 'react-i18next'

import { CoinsIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Card, CardTitle } from '@reveni-io/reveni-ui'

import CardDescription from '@/metrics/components/CardDescription/CardDescription'
import MenuCard from '@/metrics/components/MenuCard/MenuCard'

import RefundMethodsList from './RefundMethodsList/RefundMethodsList'
import * as Styles from './styles'

const RefundMethodsCard = ({
  numOfAvailableRefundMethods,
  totalRefunds,
  totalAmount,
  refundMethods,
  loading,
  currency,
  onExport,
  refundMethodsFilters,
  onChangeRefundMethodsFilters,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Card showBorder={false}>
      <CardTitle marginBottom={theme.spacing.sp16}>
        <Styles.Title>
          <CoinsIcon size={24} />
          {t('Métodos de reembolso')}
        </Styles.Title>
        <MenuCard cardName={t('Métodos de reembolso')} onExport={onExport} />
      </CardTitle>
      <CardDescription>
        {t(
          'Del total de reembolsos realizados, desglose por método. Una misma solicitud puede generar más de un reembolso.'
        )}
      </CardDescription>
      <RefundMethodsList
        loading={loading}
        numOfAvailableRefundMethods={numOfAvailableRefundMethods}
        totalRefunds={totalRefunds}
        totalAmount={totalAmount}
        refundMethods={refundMethods}
        currency={currency}
        refundMethodsFilters={refundMethodsFilters}
        onChangeRefundMethodsFilters={onChangeRefundMethodsFilters}
      />
    </Card>
  )
}

export default RefundMethodsCard
